module.exports = __webpack_public_path__ + "static/media/222-niger.b6f20f2b.svg";